import { resolveImagePath } from '@/utils/imageMap';

export function AboutCoffee() {
  return (
    <section className="py-16 bg-cream-base">
      <div className="container mx-auto px-4">
        {/* Section Title */}
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-black mb-8" style={{ fontFamily: 'Bebas Neue, sans-serif' }}>
            Enjoy fresh brewed New Hampshire coffee
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Column - Images */}
          <div className="grid grid-cols-2 gap-6">
            <div className="flex justify-center">
              <img 
                src={resolveImagePath("/wp-content/uploads/Dianas-NHRoastingCo-CoffeeBeans.jpg")}
                alt="NH Coffee Roasting Co - Fresh Coffee!"
                className="w-full max-w-[200px] rounded-lg shadow-lg"
              />
            </div>
            <div className="flex justify-center">
              <img 
                src={resolveImagePath("/wp-content/uploads/Dianas-EddyTheEgg-Drawing-1.jpg")}
                alt="Eddie the Egg"
                className="w-full max-w-[200px] rounded-lg shadow-lg"
              />
            </div>
          </div>

          {/* Right Column - Content */}
          <div className="space-y-8">
            {/* Hours */}
            <div>
              <h3 className="text-2xl font-bold text-black mb-4" style={{ fontFamily: 'Bebas Neue, sans-serif' }}>
                HOURS:
              </h3>
              <div className="text-lg text-black font-medium space-y-1" style={{ fontFamily: 'Roboto, sans-serif' }}>
                <p>Monday: 7:00 - 1:30</p>
                <p>Tues. & Wed.: Closed</p>
                <p>Thursday: 7:00 - 1:30</p>
                <p>Friday: 7:00 - 1:30</p>
                <p>Saturday: 6:00 - 1:30</p>
                <p>Sunday: 6:00 - 1:00</p>
              </div>
            </div>

            {/* Diana's Message */}
            <div>
              <p className="text-lg text-black leading-relaxed mb-4" style={{ fontFamily: 'Roboto, sans-serif' }}>
                Good food can't be rushed. We take pride in our food, it may take longer when we have a full house but remember it doesn't come out of a can or a bag. It's worth the wait. So please come in, relax a...
              </p>
              <p className="text-lg text-black font-medium italic" style={{ fontFamily: 'Roboto, sans-serif' }}>
                Diana
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}